import firebase from 'firebase';

class UserStore {
    users = {};
    callbacks = [];
    uid='1234';
    skillsObj = {};

    login() {
        //console.log("UserStore login");
        this.authed = true;
    }

    setGlobal(key, value){
      this[key] = value;
    }

    getGlobal(key){
      return this[key];
    }

    fetchGlobals(){
      firebase.database().ref(`skills`).on('value', snapshot => {
          let topicData = snapshot.val();
          if (!!topicData) {
              this.setGlobal("topicObj", topicData);
          }
      });
      return firebase.database().ref(`cats`).on('value', snapshot => {
        let catData = snapshot.val();
        if (!!catData){
          this.setGlobal("catObj", catData);
          this.callbacks.map(cb=>{ cb(); });
        }
      });

    }

    setUserInfo(email, displayName, photoURL, uid, taskNum) {
        console.log("UserStore fetchUserInfo");
        this.email = email;
        this.displayName = displayName;
        this.photoURL = photoURL;
        this.uid = uid;
        this.taskNum = taskNum;
        firebase.database().ref(`users`).child(uid).child('skills').on('value', snapshot => {
            let skillsData = snapshot.val();
            if (!!skillsData) {
                this.setGlobal("skillsObj", skillsData);
                this.callbacks.map(cb=>{ cb(); });
            }
        });
    }

    registerCallback(callback){
      this.callbacks.push(callback);
    }

    unregister(callback){
      this.callbacks = this.callbacks.filter(x=>x!=callback);
    }

    setUsers(usersObj){
        this.users = usersObj;
        console.log(usersObj);
        this.callbacks.map(cb=>{ cb(); });
    }

    logout() {
        //console.log("UserStore logout");
        this.authed = false;
        this.email = "";
        this.displayName = "";
        this.photoURL = "";
        this.uid = "";
        this.role = "";
        this.callbacks.map(cb=>{ cb(); });
    }
}

const userStore = new UserStore();
export default userStore;



// WEBPACK FOOTER //
// ./src/store/UserStore.js